// The fields that make a return address "entered". Mirrors AddressForm#addressFields, and
// deliberately excludes `country`: the form writes it as 'US' whether or not anything was typed
// (AddressForm#getAddress), so any emptiness test that includes it reads a cleared address as a
// filled one.
export const RETURN_ADDRESS_FIELDS = [
  'name',
  'streetAdd1',
  'streetAdd2',
  'city',
  'state',
  'zip',
];

/**
 * Whether an address has anything in it.
 *
 * Emptying either address form writes every field back as a blank string rather than removing
 * the keys, so counting keys says "filled" for an address the customer cleared.
 *
 * Not the server's CartItem::PrismPropertyFinder::RETURN_ADDRESS_FIELDS, which is wider and
 * includes `country` - by that list an emptied address is never blank. The forms decide what
 * the customer entered, so AddressForm#addressFields is the list to match here.
 *
 * @param {object} [address] the `wkData.values.returnAddress` object
 * @returns {boolean}
 */
export const hasReturnAddress = (address) =>
  RETURN_ADDRESS_FIELDS.some((field) => String(address?.[field] ?? '').trim());

export default hasReturnAddress;
